import React from 'react'

const statusColors = {
  Active: { bg: '#dcfce7', text: '#166534', border: '#bbf7d0' },
  Inactive: { bg: '#f3f4f6', text: '#374151', border: '#e5e7eb' },
  Done: { bg: '#dbeafe', text: '#1e40af', border: '#c7d2fe' }
}

export default function StatusBreakdown({ clients }) {
  const getStatusCounts = () => {
    const statusCounts = clients.reduce((acc, client) => {
      acc[client.status] = (acc[client.status] || 0) + 1
      return acc
    }, {})

    return [
      { status: 'Active', count: statusCounts.Active || 0 },
      { status: 'Inactive', count: statusCounts.Inactive || 0 },
      { status: 'Done', count: statusCounts.Done || 0 }
    ]
  }

  const statusData = getStatusCounts()
  const total = clients.length

  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '20px 24px',
        borderBottom: '1px solid #e5e7eb'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#111827',
          margin: 0
        }}>
          Status Breakdown
        </h3>
      </div>

      {/* Content */}
      <div style={{ 
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}>
        {statusData.map(({ status, count }) => (
          <div key={status} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <span style={{
                display: 'inline-flex',
                padding: '4px 12px',
                fontSize: '12px',
                fontWeight: '500',
                borderRadius: '20px',
                backgroundColor: statusColors[status].bg,
                color: statusColors[status].text,
                border: `1px solid ${statusColors[status].border}`
              }}>
                {status}
              </span>
              <span style={{
                fontSize: '14px',
                color: '#6b7280'
              }}>
                {total > 0 ? Math.round((count / total) * 100) : 0}%
              </span>
            </div>
            <span style={{
              fontWeight: '600',
              color: '#111827'
            }}>
              {count}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}